import script from "./TableOfContent.vue?vue&type=script&setup=true&lang=js"
export * from "./TableOfContent.vue?vue&type=script&setup=true&lang=js"

import "./TableOfContent.vue?vue&type=style&index=0&id=167681a1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-167681a1"]])

export default __exports__